export const UPDATE_COURT_NAME = 'UPDATE_COURT_NAME'
export const UPDATE_TOKEN = 'UPDATE_TOKEN'
export const UPDATE_USERNAME = 'UPDATE_USERNAME'
export const UPDATE_JOBNUMBER = 'UPDATE_JOBNUMBER'
export const UPDATE_WINDOW = 'UPDATE_WINDOW'
export const UPDATE_SERVICE = 'UPDATE_SERVICE'
export const UPDATE_QUEUENO = 'UPDATE_QUEUENO'
